import React from 'react';
import { Box, CircularProgress } from '@mui/material';

import { Typography } from '../Typography';
import { EmptyDataTable } from '../EmptyDataTable';

export const renderErrorState = () => {
  return (
    <Box p={4}>
      <Typography color='error' data-testid='table-data-error-message'>
        Something went wrong. Please try again.
      </Typography>
    </Box>
  );
};

export const renderLoadingState = () => {
  return (
    <Box display='flex' justifyContent='center' alignItems='center' p={3}>
      <CircularProgress />
    </Box>
  );
};

export const renderNoDataState = () => {
  return (
    <Box p={4}>
      <Typography color='error' data-testid='table-no-data-message'>
        No data. Something went wrong. Please try again.
      </Typography>
    </Box>
  );
};

export const renderEmptyState = () => {
  return <EmptyDataTable testId='table-empty-message' />;
};
